export const MENU_KEYS = {
  SYSTEM: "system",
  SYSTEM_ELEMENTS: "system.elements",
  SYSTEM_VARIABLES: "system.variables",
  UNITS: "units",
  UNITS_ELEMENTS: "units.elements",
  UNITS_VARIABLES: "units.variables",
  INTERCONN: "interconn",
  INTERCONN_ELEMENTS: "inteconn.elements",
  INTERCONN_VARIABLES: "interconn.variables",
  LOAD: "load",
  LOAD_ELEMENTS: "load.elements",
  LOAD_VARIABLES: "load.variables",
  FINANCIAL: "financial",
  FINANCIAL_ELEMENTS: "financial.elements",
  FINANCIAL_VARIABLES: "financial.variables",
};




// WEBPACK FOOTER //
// ./src/views/info/constants.js